module.exports = __webpack_public_path__ + "img/theCover_02.e5ad3879.jpg";